module.exports = __webpack_public_path__ + "img/calendar.4043f690.svg";